import * as React from 'react'
import { useState, useRef, useEffect } from 'react'
import cmtyStyle from './community.module.less'
import {
  Button,
  Col,
  Divider,
  Row,
  Tabs,
  message,
  Checkbox,
  ConfigProvider,
  Pagination,Tooltip
} from 'antd'
import DiscusItemStyle from '../../component/DiscussItem/DiscussItem.module.less'
import SearchInputCom from '../../component/SearchInputCom/SearchInputCom'
import { useHistory } from 'react-router-dom'
import { sendHttpPostRequest } from '../../api/http-request'
import Cookies from 'js-cookie'
import { BACKEND_API_URL } from '../../constants/constants'
import CommunityAgreement from './CommunityAgreement'
import zhCN from 'antd/lib/locale/zh_CN'
import { SwapOutlined , MessageOutlined, EyeOutlined, LikeOutlined} from '@ant-design/icons'
import emptyCourse from '../../static/image/empty/queshengye-kecheng.png'

interface Props {}

export const Community = (props: Props) => {
  const [agreementRead, setAgreementRead] = useState(true)
  const queryContent = useRef('') // 记录搜索串
  const order = useRef('descend') // 排序升序降序
  const orderBy = useRef('publish_time') // 排序列
  const page = useRef(1) // 记录当前的页数
  const pageSize = useRef(10) // 记录当前每页展示数量
  const [resultSum, setResultSum] = useState(0) // 搜索返回的结果数
  const [checkedAgreementRead, setCheckedAgreementRead] = useState(false) // 勾选我已阅读并同意
  const [todayMyPublishCount, setTodayMyPublishCount] = useState(0) // 我今天发文数
  const [myPublishCount, setMyPublishCount] = useState(0) // 我累计发文数
  const [myAvatar, setMyAvatar] = useState(
    'static/avatar/default_avatar.png'
  ) // 我的头像
  const [myName, setMyName] = useState('') // 我的名字
  const [articleLoaded, setArticleLoaded] = useState(false) // 加载中
  // const currentTab = useRef("new")  // 当前tab
  const recommendPage = useRef(1) // 记录当前的页数
  const recommendPageSize = useRef(10) // 记录当前每页展示数量
  const [recommendResultSum, setRecommendResultSum] = useState(0) // 搜索返回的结果数

  const [isLogin, setIsLogin] = useState(false) //是否登录

  const history = useHistory()

  const [articleList, setArticleList] = useState([] as any[])

  const changeTab = window.location.search
  const currentTab = useRef(
    changeTab && changeTab == '?tab=3'
      ? 'my'
      : changeTab && changeTab == '?tab=2'
      ? 'hot'
      : 'new'
  ) // 当前tab

  const [recommendList, setRecommendList] = useState([] as any[])

  // 搜索框输入变化
  const searchInputChange = (e) => {
    queryContent.current = e.target.value
  }

  /**
   * 切换tab
   * @param key
   */
  const onTabkeyChange = (key: string) => {
    currentTab.current = key
    onSearch()
  }

  /**
   * 搜索
   */
  const onSearch = () => {
    page.current = 1
    let url: string =
      currentTab.current == 'my'
        ? 'community/api/query_my_post_list/'
        : 'community/api/query_public_post_list/'
    orderBy.current = currentTab.current == 'hot' ? 'hot' : 'publish_time'
    queryArticleList(url)
  }

  useEffect(() => {
    sendHttpPostRequest(
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.is_ok == true) {
          setIsLogin(true)
        }else{
          setIsLogin(false)
        }
      }
    )

    onSearch()
    queryMyArticleCount()
    queryRecommendArticleList()
  }, [])

  /**
   * 查文章列表
   * @param url
   */
  const queryArticleList = (url = 'community/api/query_public_post_list/') => {
    setArticleLoaded(false)
    sendHttpPostRequest(
      url,
      {
        sessionid: Cookies.get('sessionid'),
        query: queryContent.current,
        page: page.current,
        pagesize: pageSize.current,
        order: order.current,
        order_by: orderBy.current,
      },
      (response: any) => {
        setArticleLoaded(true)
        message.destroy()

        if (response.code == -100) {
          // 未登录
          currentTab.current == 'my'
            ? (window.location.href = '/login?next=community')
            : ''
          setArticleList(response.query_list)
          setResultSum(response.total_sum)
        } else if (response.code == 0) {
          // 成功
          setArticleList(response.query_list)
          setResultSum(response.total_sum)
          setAgreementRead(true)
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/login?next=community'
        } else if (response.code == -509) {
          // 未阅读社区协议
          setAgreementRead(false)
          setArticleList([])
          setResultSum(0)
          setTodayMyPublishCount(0)
          setMyPublishCount(0)
        } else {
          message.error(response.message)
        }

        if (changeTab) {
          const newSearch = changeTab.substring(0, changeTab.indexOf('?'))
          window.history.replaceState(null, '', `community`)
        }
      }
    )
  }

  /**
   * 查我的文章总数
   * @param url
   */
  const queryMyArticleCount = (url = 'community/api/query_my_post_count/') => {
    sendHttpPostRequest(
      url,
      {
        sessionid: Cookies.get('sessionid'),
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          // window.location.href = '/login?next=community';
        } else if (response.code == 0) {
          // 成功
          setMyName(response.myself.name)
          setMyAvatar(response.myself.avatar)
          setTodayMyPublishCount(response.today_my_publish_count)
          setMyPublishCount(response.my_publish_count)
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/login?next=community'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /**
   * 查推荐文章列表
   */
  const queryRecommendArticleList = () => {
    sendHttpPostRequest(
      'community/api/query_top_post_list/',
      {
        sessionid: Cookies.get('sessionid'),
        page: recommendPage.current,
        pagesize: recommendPageSize.current,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          // window.location.href = '/login?next=community';
        } else if (response.code == 0) {
          // 成功
          setRecommendList(response.query_list)
          setRecommendResultSum(response.total_sum)
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/login?next=community'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 点了复选框
  const onOptionsChange = (event: any) => {
    setCheckedAgreementRead(!checkedAgreementRead)
  }

  // 点击继续
  const onContinue = (event: any) => {
    message.destroy()
    if (!checkedAgreementRead) {
      message.error('请认真阅读社区协议并勾选“我已阅读并同意”')
    } else {
      sendHttpPostRequest(
        'community/api/read_community_agreement/',
        {
          sessionid: Cookies.get('sessionid'),
        },
        (response: any) => {
          message.destroy()
          if (response.code == -100) {
            // 未登录
            window.location.href = '/login?next=community'
          } else if (response.code == 0) {
            // 成功
            onSearch()
          } else if (response.code == -501) {
            // 权限不足
            window.location.href = '/login?next=community'
          } else {
            message.error(response.message)
          }
        }
      )
    }
  }

  const newArticleBtnClick = () => {
    if(isLogin == true){
      history.push('/community-article-create')
    }else {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    }
    
  }

  const onPageSizeChange = (newPage, newPageSize) => {
    page.current = newPage
    pageSize.current = newPageSize
    queryArticleList()
  }

  const articleListRender = (
    <div className={cmtyStyle.listContain}>
      {articleList?.map((article) => (
        <div
          key={article?.id}
          className={cmtyStyle.articleInfo}
          onClick={() => {
            if(isLogin == true){
              window.open(`/community-article-detail?id=${article?.id}`)}
            else{
              sessionStorage.setItem("previousurl",window.location.href )
              document.getElementById('show-login-modal')!.click()
            }
          }
          }
        >
          <Row align={'middle'} wrap={false}>
            <Col flex="auto">
            <h1 className={cmtyStyle.articleTitle}>{article?.title}</h1>
            <div className={cmtyStyle.articleMain}>{article?.content}</div>
            </Col>

        {article?.content_image_url !== '' && <Col style={{marginLeft:10}} flex={'180px'}> 
        
            <img          style={{height:100, width:180, borderRadius:'10px', marginRight:5}}
                  src={article?.content_image_url}/></Col>}
          </Row>



          <Row align={'middle'} wrap={false}>
            <Col flex='29px'>
                <img
                  style={{height:24, width:24, borderRadius:'50%', marginRight:5}}
                  src={BACKEND_API_URL + article?.creator_avatar}
                  alt=""
                />
              </Col>
            <Col flex='100px' style={{textWrap:'nowrap',marginRight:10,width:100,textOverflow:'ellipsis', overflow:'hidden', color:'#333',fontWeight:400}}>{article?.creator_name}</Col>
            <Col flex={'auto'} className={cmtyStyle.timeBox}>
            {article?.publish_time}
            </Col>
            <Col flex='50px' style={{color:'#999',textOverflow:'ellipsis', overflow:'hidden',textWrap:'nowrap', marginLeft:5}} > <EyeOutlined /> {article?.view_count} </Col>
            <Col flex='50px' style={{color:'#999',textOverflow:'ellipsis', overflow:'hidden',textWrap:'nowrap', marginLeft:5}} > <LikeOutlined /> {article?.praised_count} </Col>
            <Col flex='50px' style={{color:'#999',textOverflow:'ellipsis', overflow:'hidden',textWrap:'nowrap', marginLeft:5}} > <MessageOutlined /> {article?.reply_count} </Col>
          </Row>
        </div>
      ))}

        <div      style={{ marginBottom: 30, paddingTop: 30 }}
                  className={'css.pagination'}>
          <ConfigProvider locale={zhCN}>
            <Pagination
              total={resultSum}
              current={page.current}
              pageSize={pageSize.current}
              onChange={onPageSizeChange}
              //showQuickJumper
              hideOnSinglePage
              //pageSizeOptions={['10', '20', '50', '100']}
            />
          </ConfigProvider>
        </div>
    </div>
  )

  const recommendListRender = (
    <div className={cmtyStyle.recommendList}>
      {recommendList?.map((recommend) => (
        <div
          className={cmtyStyle.recommendItem}
          key={recommend?.id}
          onClick={() =>
            window.open(`/community-article-detail?id=${recommend?.id}`)
          }
        >
          <h1 className={cmtyStyle.articleTitle}>{recommend?.title}</h1>
          <div style={{ margin: '0px' }} className={cmtyStyle.articleMain}>
            {recommend?.content}
          </div>
        </div>
      ))}
    </div>
  )
  return (
    <div className={cmtyStyle.mainContent}>
      <div className={cmtyStyle.contentBox}>
        {agreementRead && (
          <div className={cmtyStyle.leftMain}>
            <Row
              className={cmtyStyle.header}
              justify={'space-between'}
              align={'middle'}
            >
              <Col>
                <SearchInputCom
                  placeholder={'根据标题/内容关键字搜索'}
                  onChange={searchInputChange}
                  onSearch={onSearch}
                />
              </Col>
              <Col>
                <Button
                  className={cmtyStyle.radiusBtn}
                  style={{textShadow:'none', boxShadow:'none' }}
                  type={'primary'}
                  onClick={newArticleBtnClick}
                >
                  + 发 文
                </Button>
              </Col>
            </Row>
            <Tabs
              onChange={onTabkeyChange}
              defaultActiveKey={currentTab.current}
            >
              <Tabs.TabPane tab={'最新'} key={'new'}>
                {articleListRender}
              </Tabs.TabPane>
              <Tabs.TabPane tab={'最热'} key={'hot'}>
                {articleListRender}
              </Tabs.TabPane>

             { isLogin == true && <Tabs.TabPane tab={'我的'} key={'my'}>
                
                { myPublishCount == 0 && 
          <div  style={{paddingTop:60, textAlign:'center', paddingBottom:60}}>
              <img src={emptyCourse} height={150} />
              <div style={{ marginTop:20, color: '#999999' }}>
                你还没有文章，发表第一个文章吧
              </div>
          </div>
        }

            {articleListRender}
              </Tabs.TabPane> }
            </Tabs>
          </div>
        )}
        {!agreementRead && articleLoaded && (
          <div
            className={cmtyStyle.leftMain}
            hidden={!articleLoaded}
            style={agreementRead ? { display: 'none' } : { display: 'block' }}
          >
            <CommunityAgreement />
            <div>
              <Checkbox
                style={{
                  padding: 5,
                  minHeight: 30,
                  alignItems: 'center',
                  alignContent: 'center',
                }}
                key={1}
                value={1}
                onChange={onOptionsChange}
              >
                <span style={{ top: 3, position: 'relative' }}>
                  我已阅读并同意
                </span>
              </Checkbox>
              <Button onClick={onContinue}>继续</Button>
            </div>
          </div>
        )}
        <div className={cmtyStyle.rightMain}>
          <div className={cmtyStyle.userMain}>
            <Row align={'middle'} justify={'start'}>
              <Col>
                <img
                  className={cmtyStyle.userAvatar}
                  src={BACKEND_API_URL + myAvatar}
                  alt=""
                />
              </Col>
              <Col className={cmtyStyle.userName}>{isLogin == true? myName :'未登录'}</Col>
            </Row>
            <div className={cmtyStyle.statistic}>
              <div className={cmtyStyle.statisticInfo}>
                <div className={cmtyStyle.statisticTitle}>今日发文数</div>
                <div className={cmtyStyle.statisticNum}>
                  {todayMyPublishCount}
                </div>
              </div>
              <Divider style={{ height: '100%' }} type={'vertical'} />
              <div className={cmtyStyle.statisticInfo}>
                <div className={cmtyStyle.statisticTitle}>总发文数</div>
                <div className={cmtyStyle.statisticNum}>{myPublishCount}</div>
              </div>
            </div>
          </div>
          <div className={cmtyStyle.recommendMain}>
            <div className={cmtyStyle.recommendTitle}>
              推荐
              <Tooltip placement="top" title={'换一批'}>
                <SwapOutlined className={cmtyStyle.exchangeBtn} onClick={()=>{queryRecommendArticleList()}}/>
              </Tooltip>
              
            </div>
            {recommendListRender}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Community
